import { IconBaseType } from "@/v2-components/core/icon/type";
import { cn } from "@/libs/utils";

export default function MetaBlueIcon({ className }: IconBaseType) {
  return (
    <svg
      className={cn("h-6 w-6", className)}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.77009 14.2296C3.77009 15.0342 3.94662 15.6519 4.17752 16.0256C4.48017 16.5151 4.93155 16.7228 5.39175 16.7228C5.98523 16.7228 6.52823 16.5755 7.57458 15.1283C8.41308 13.9683 9.40066 12.3401 10.0653 11.3194L11.1908 9.59003C11.9726 8.38904 12.8776 7.05397 13.9152 6.14901C14.7626 5.41034 15.6761 5 16.5957 5C18.1397 5 19.6103 5.89472 20.7358 7.57278C21.9676 9.41051 22.5655 11.7254 22.5655 14.1141C22.5655 15.5343 22.2857 16.5777 21.8093 17.4021C21.3492 18.1993 20.4523 18.9959 18.9435 18.9959V16.7225C20.2354 16.7225 20.5577 15.5353 20.5577 14.1768C20.5577 12.2408 20.1064 10.0924 19.112 8.55727C18.4064 7.46837 17.4919 6.80304 16.4858 6.80304C15.3976 6.80304 14.5219 7.62388 13.5378 9.08702C13.0146 9.86453 12.4775 10.8119 11.8744 11.8811L11.2105 13.0572C9.87702 15.4222 9.53915 15.9606 8.87232 16.8492C7.70363 18.4055 6.70555 18.9955 5.39175 18.9955C3.83311 18.9955 2.84757 18.3206 2.23714 17.3035C1.73889 16.4748 1.49414 15.3873 1.49414 14.1483L3.77009 14.2296Z"
        fill="#0081FB"
      />
      <path
        d="M3.28906 7.73324C4.33251 6.12482 5.83837 5 7.5655 5C8.56569 5 9.56024 5.29603 10.5984 6.14389C11.7342 7.07065 12.9447 8.5976 14.455 11.1131L14.9965 12.0156C16.3037 14.1934 17.0474 15.3138 17.4827 15.8421C18.0425 16.5206 18.4346 16.7229 18.9438 16.7229C20.2358 16.7229 20.5581 15.5358 20.5581 14.1772L22.5659 14.1142C22.5659 15.5344 22.286 16.5778 21.8097 17.4022C21.3495 18.1994 20.4526 18.996 18.9438 18.996C18.0059 18.996 17.175 18.7923 16.2561 17.9253C15.55 17.26 14.7238 16.0781 14.0885 15.0156L12.1987 11.8588C11.2506 10.2746 10.3805 9.09338 9.87737 8.55841C9.33579 7.98312 8.63966 7.28849 7.52878 7.28849C6.62973 7.28849 5.86617 7.91939 5.22723 8.88446L3.28906 7.73324Z"
        fill="url(#paint0_linear_12834_36139)"
      />
      <path
        d="M7.52842 7.28849C6.62938 7.28849 5.86581 7.91939 5.22687 8.88446C4.32333 10.2481 3.77053 12.2793 3.77053 14.2299C3.77053 15.0345 3.94706 15.6522 4.17796 16.0259L2.23714 17.3039C1.73889 16.4752 1.49414 15.3877 1.49414 14.1486C1.49414 11.8954 2.1126 9.54687 3.28871 7.73324C4.33215 6.12482 5.83801 5 7.56514 5L7.52842 7.28849Z"
        fill="url(#paint1_linear_12834_36139)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12834_36139"
          x1="5.55767"
          y1="16.9023"
          x2="20.004"
          y2="18.2864"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0064E1" />
          <stop offset="0.4" stopColor="#0064E1" />
          <stop offset="0.83" stopColor="#0073EE" />
          <stop offset="1" stopColor="#0082FB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_12834_36139"
          x1="5.8493"
          y1="15.1855"
          x2="5.8493"
          y2="9.83629"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0082FB" />
          <stop offset="1" stopColor="#0064E0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
